<template>

<div class="col-8">
<div class="editor_viewport_wrap" ref="editor_viewport_wrap">
<div class="editor_viewport animate_class" :style="'width:'+editor_viewport_width">


<draggable 
v-model="schema"
data_container_id="display_parent"
group="parent" 
@start="start" 
@end="end" 
@change="change"
handle=".block_handle"
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<SchemaEditorDisplayParentBlock 
:block="element" 
/>

</template>
</draggable>


</div>
</div>
</div>

</template>

<script>
import SchemaEditorDisplayParentBlock from "./SchemaEditorDisplayParentBlock"
export default {

  name: 'SchemaEditorDisplay',
  props:["view_mode"],
  data () {
    return {
    	drag:false,
    	schema:null,
    }
  },
  components:{SchemaEditorDisplayParentBlock},
  watch:{
  	blocks(newval,oldval)
  	{
  		this.schema = this.$store.state.customresultdisplays.schema
  	},
  },
  computed:{
  	blocks()
  	{
  		return this.$store.state.customresultdisplays.schema
  	},
  	editor_viewport_width()
  	{
  		if(this.view_mode=="desktop")
  		{
  			return "100%"
  		}
  		if(this.view_mode=="mobile")
  		{
  			return "390px"
  		}
  	},
  	dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    },
  },
  methods:{
  	end(event)
    {
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    change(event)
    {
      this.$emit("orderChanged",this.schema)
    },
  }
}
</script>

<style lang="css" scoped>

.editor_viewport_wrap{
	width: 100%;
	min-height: 100px;
	padding: 12px;
	display: flex;
	justify-content: center;
}
.editor_viewport{
	border-radius: 8px;
	padding: 8px;
	background-color: #fff;
	min-height: 100px;
	box-shadow: rgb(93 62 188 / 10%) 0px 6px 24px;
}
</style>